import {isString} from './types'

let map = {}, support

if (!('localStorage' in window)) support = false
try {
  window.localStorage.setItem('___test', 'OK')
  const result = window.localStorage.getItem('___test')
  window.localStorage.removeItem('___test')
  support = (result === 'OK')
} catch (err) {
  support = false
}

function localStorage(namespace, getDefValue) {
  if (!namespace) throw 'localStorage need a valid namespace'
  if (!map[namespace]) {
    let storage
    if (support) storage = window.localStorage.getItem(namespace)
    if (!!storage && isString(storage)) storage = JSON.parse(storage)
    else if (getDefValue) storage = getDefValue(support)
    else storage = {}
    //__clean__
    Object.defineProperty(storage, '__clean__', {
      writable: false, enumerable: false, configurable: false, value: function () {
        for (let key in storage) delete storage[key]
        if (support) window.localStorage.removeItem(namespace)
      }
    })
    //__save__
    Object.defineProperty(storage, '__save__', {
      writable: false, enumerable: false, configurable: false, value: function () {
        if (support) window.localStorage.setItem(namespace, JSON.stringify(storage))
      }
    })
    map[namespace] = storage
  }
  return map[namespace]
}

export {support, localStorage}
